"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalFields = exports.InternalFields = exports.DefaultFieldNames = void 0;
var DefaultFieldNames;
(function (DefaultFieldNames) {
    DefaultFieldNames["cmhcDefaultAccountID"] = "cmhcDefaultAccountID";
    DefaultFieldNames["cmhcLoanAccountNumber"] = "cmhcLoanAccountNumber";
    DefaultFieldNames["approvedLenderName"] = "approvedLenderName";
    DefaultFieldNames["approvedLenderCode"] = "approvedLenderCode";
    DefaultFieldNames["approvedLenderReferenceNumber"] = "approvedLenderReferenceNumber";
    DefaultFieldNames["cmhcOwnerFirstName"] = "cmhcOwnerFirstName";
    DefaultFieldNames["cmhcOwnerID"] = "cmhcOwnerID";
    DefaultFieldNames["cmhcOwnerLastName"] = "cmhcOwnerLastName";
    DefaultFieldNames["correspondenceLanguage"] = "correspondenceLanguage";
    DefaultFieldNames["defaultStatus"] = "defaultStatus";
    DefaultFieldNames["lastRecordUpdatedTimestamp"] = "lastRecordUpdatedTimestamp";
    DefaultFieldNames["lastRecordUpdatedUserFirstName"] = "lastRecordUpdatedUserFirstName";
    DefaultFieldNames["lastRecordUpdatedUserID"] = "lastRecordUpdatedUserID";
    DefaultFieldNames["lastRecordUpdatedUserLastName"] = "lastRecordUpdatedUserLastName";
    DefaultFieldNames["provinceCode"] = "provinceCode";
    DefaultFieldNames["requestCreatedUserFirstName"] = "requestCreatedUserFirstName";
    DefaultFieldNames["requestCreatedUserID"] = "requestCreatedUserID";
    DefaultFieldNames["requestCreatedUserLastName"] = "requestCreatedUserLastName";
    DefaultFieldNames["requestReceivedTimestamp"] = "requestReceivedTimestamp";
    DefaultFieldNames["submittedDefaultStage"] = "submittedDefaultStage";
    DefaultFieldNames["validLoan"] = "validLoan";
})(DefaultFieldNames = exports.DefaultFieldNames || (exports.DefaultFieldNames = {}));
exports.InternalFields = [
    DefaultFieldNames.cmhcDefaultAccountID,
    DefaultFieldNames.cmhcLoanAccountNumber,
    DefaultFieldNames.approvedLenderCode,
    DefaultFieldNames.approvedLenderName,
    DefaultFieldNames.approvedLenderReferenceNumber,
    DefaultFieldNames.cmhcOwnerFirstName,
    DefaultFieldNames.cmhcOwnerID,
    DefaultFieldNames.cmhcOwnerLastName,
    DefaultFieldNames.correspondenceLanguage,
    DefaultFieldNames.defaultStatus,
    DefaultFieldNames.lastRecordUpdatedTimestamp,
    DefaultFieldNames.lastRecordUpdatedUserFirstName,
    DefaultFieldNames.lastRecordUpdatedUserID,
    DefaultFieldNames.lastRecordUpdatedUserLastName,
    DefaultFieldNames.provinceCode,
    DefaultFieldNames.requestCreatedUserFirstName,
    DefaultFieldNames.requestCreatedUserID,
    DefaultFieldNames.requestCreatedUserLastName,
    DefaultFieldNames.requestReceivedTimestamp,
    DefaultFieldNames.submittedDefaultStage,
    DefaultFieldNames.validLoan,
];
exports.ExternalFields = [
    DefaultFieldNames.cmhcDefaultAccountID,
    DefaultFieldNames.cmhcLoanAccountNumber,
    DefaultFieldNames.approvedLenderCode,
    DefaultFieldNames.approvedLenderName,
    DefaultFieldNames.approvedLenderReferenceNumber,
    DefaultFieldNames.defaultStatus,
    DefaultFieldNames.lastRecordUpdatedTimestamp,
    DefaultFieldNames.requestCreatedUserFirstName,
    DefaultFieldNames.requestCreatedUserID,
    DefaultFieldNames.requestCreatedUserLastName,
    DefaultFieldNames.requestReceivedTimestamp,
    DefaultFieldNames.validLoan,
];
